export type ScanStatus = "clear" | "risk";

export type ScanSample = {
  id: string;
  area: string;
  capturedAt: string;
  image: string;
  melanomaProbability: number;
  dermatologistNote: string;
  status: ScanStatus;
};

const baseHandImage =
  "https://images.unsplash.com/photo-1619983081593-e2ba5f80d099?auto=format&fit=crop&w=900&q=80";

const highRiskImage =
  "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&w=900&q=80";

export const mockScanSamples: Record<string, ScanSample> = {
  handClear: {
    id: "hand-clear",
    area: "Hand",
    capturedAt: "2025-11-05T09:15:00Z",
    image: baseHandImage,
    melanomaProbability: 0.03,
    dermatologistNote:
      "No suspicious features detected. Continue monitoring every 30 days.",
    status: "clear",
  },
  handRisk: {
    id: "hand-risk",
    area: "Hand",
    capturedAt: "2025-11-08T13:45:00Z",
    image: highRiskImage,
    melanomaProbability: 0.87,
    dermatologistNote:
      "Irregular borders and rapid growth detected. Please schedule an in-person consultation.",
    status: "risk",
  },
};

export const mockHistoricalScans: ScanSample[] = [
  {
    id: "scan-001",
    area: "Left Forearm",
    capturedAt: "2025-10-22T15:18:00Z",
    image: baseHandImage,
    melanomaProbability: 0.05,
    dermatologistNote: "No pigment asymmetry. Maintain sun protection.",
    status: "clear",
  },
  {
    id: "scan-002",
    area: "Right Shoulder",
    capturedAt: "2025-09-18T08:05:00Z",
    image:
      "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=900&q=80",
    melanomaProbability: 0.12,
    dermatologistNote: "Mild irritation detected. Review with GP if persists.",
    status: "clear",
  },
  {
    id: "scan-003",
    area: "Upper Back",
    capturedAt: "2025-07-03T18:32:00Z",
    image:
      "https://images.unsplash.com/photo-1552346154-21d32810aba3?auto=format&fit=crop&w=900&q=80",
    melanomaProbability: 0.42,
    dermatologistNote: "Monitor for changes in elevation and color.",
    status: "risk",
  },
];
